import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

    // Define las rutas de las imágenes
    const pngPaths = {
        1: "/images/icons/unloads-levels/1-vibration-128-orange.png",
        2: "/images/icons/unloads-levels/2-empty-bin-128-green.png",
        4: "/images/icons/unloads-levels/4-manual-128-blue.png",
        // Nota: No tienes una ruta definida para el nivel 3,
        // tu lógica original intentaba usar icons[2] e icons[3]
    };

    // Crea un componente pequeño para renderizar el icono correcto
    const IconForLevel = ({ level }) => {
        // Estilos opcionales para controlar el tamaño
        const urlStatic = process.env?.REACT_APP_STATIC_URL || "/static";
        switch (parseInt(level)) {
            case 1:
                return <img src={urlStatic + pngPaths[1]} alt="1" />;
            case 2:
                return <img src={urlStatic + pngPaths[2]} alt="2" />;
            case 3:
                return (
                    <>
                        <img src={urlStatic + pngPaths[1]} alt="1"/>
                        <img src={urlStatic + pngPaths[2]} alt="2"/>
                    </>
                );
            case 4:
                return <img src={urlStatic + pngPaths[4]} alt="4"/>;
            case 5:
                return <FontAwesomeIcon icon="truck-field" className="text-success" />;
            default:
                // No renderizar nada si el nivel no coincide
                return null;
        }
    };

    // Ya no necesitas exportar setIcons o getIcon de la forma anterior
    export default IconForLevel;
